// extracted by mini-css-extract-plugin
module.exports = {"wrapCharContent":"style_wrapCharContent__2PX-y"};